/**
 * App base URL helpers.
 *
 * Defaults to `https://app.h3ight.com` in production and `window.location.origin`
 * in local dev. Override with `VITE_APP_BASE_URL` when the platform admin and
 * app are served from different origins.
 */
export function getAppBaseUrl(): string {
  const envUrl = import.meta.env.VITE_APP_BASE_URL;
  if (envUrl) {
    return envUrl.replace(/\/+$/, '');
  }

  if (import.meta.env.PROD) {
    return 'https://app.h3ight.com';
  }

  return window.location.origin;
}

export function getAppLoginUrl(): string {
  return `${getAppBaseUrl()}/login`;
}
